module.exports = __webpack_public_path__ + "img/snacks4.452f4a8c.jpg";